'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DeleteOutlined = _interopRequireDefault(require('./lib/icons/DeleteOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _DeleteOutlined;
exports.default = _default;
module.exports = _default;